(function() {
  function initStoreSliders() {
    document.querySelectorAll('.custom-grid-section').forEach(function(section) {
      if (!section || section.classList.contains('ready')) return;
      
      var view = section.querySelector('.custom-grid-viewport');
      var track = section.querySelector('.custom-grid-track');
      var prev = section.querySelector('.custom-grid-prev');
      var next = section.querySelector('.custom-grid-next');
      var dots = section.querySelectorAll('.custom-grid-dot');
      var autoTimer = null;

      function getStepWidth() {
        var card = view.querySelector('.custom-grid-item');
        if (!card) return 0;
        var spacing = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + spacing;
      }

      function slide(dir) {
        var step = getStepWidth();
        if (step === 0) return;
        var edge = view.scrollWidth - view.clientWidth;
        var target = view.scrollLeft + (dir * step);
        
        if (target > edge + 10) target = 0;
        else if (target < -10) target = edge;
        
        view.scrollTo({ left: target, behavior: 'smooth' });
      }

      function killTimer() {
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      }

      if (prev && next) {
        prev.addEventListener('click', function() { killTimer(); slide(-1); });
        next.addEventListener('click', function() { killTimer(); slide(1); });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          killTimer();
          var step = getStepWidth();
          var index = parseInt(e.target.getAttribute('data-dot-index'));
          view.scrollTo({ left: index * step, behavior: 'smooth' });
        });
      });

      view.addEventListener('scroll', function() {
        var step = getStepWidth();
        if (step === 0 || !dots.length) return;
        var active = Math.min(dots.length - 1, Math.max(0, Math.round(view.scrollLeft / step)));
        dots.forEach(function(d, i) {
          if (i === active) d.classList.add('is-active');
          else d.classList.remove('is-active');
        });
      }, { passive: true });

      view.addEventListener('touchstart', killTimer, { passive: true });
      view.addEventListener('mousedown', killTimer, { passive: true });

      autoTimer = setInterval(function() { slide(1); }, 5000);
      section.classList.add('ready');
    });
  }

  document.addEventListener("DOMContentLoaded", initStoreSliders);
  document.addEventListener("shopify:section:load", function() { setTimeout(initStoreSliders, 100); });
})();
